
export default {
  name: "shippings",
  head(){
    return{
      title:'Τρόποι αποστολής'
    }
  },
};
